import React from 'react';

interface Props {
  className?: string;
  fill?: string;
}
export default function CrossCircleIcon({ className, fill }: Props) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92893 19.0711C8.83418 22.9763 15.1658 22.9763 19.0711 19.0711C22.9763 15.1658 22.9763 8.83418 19.0711 4.92893C15.1658 1.02369 8.83418 1.02369 4.92893 4.92893C1.02369 8.83418 1.02369 15.1658 4.92893 19.0711ZM11.8232 10.409C11.9209 10.5066 12.0791 10.5066 12.1768 10.409L14.4749 8.11091C14.6701 7.91565 14.9867 7.91565 15.182 8.11091L15.8891 8.81802C16.0843 9.01328 16.0843 9.32986 15.8891 9.52513L13.591 11.8232C13.4934 11.9209 13.4934 12.0791 13.591 12.1768L15.8891 14.4749C16.0843 14.6701 16.0843 14.9867 15.8891 15.182L15.182 15.8891C14.9867 16.0843 14.6701 16.0843 14.4749 15.8891L12.1768 13.591C12.0791 13.4934 11.9209 13.4934 11.8232 13.591L9.52513 15.8891C9.32986 16.0843 9.01328 16.0843 8.81802 15.8891L8.11091 15.182C7.91565 14.9867 7.91565 14.6701 8.11091 14.4749L10.409 12.1768C10.5066 12.0791 10.5066 11.9209 10.409 11.8232L8.11091 9.52513C7.91565 9.32986 7.91565 9.01328 8.11091 8.81802L8.81802 8.11091C9.01328 7.91565 9.32986 7.91565 9.52513 8.11091L11.8232 10.409Z"
        fill={fill || 'currentColor'}
      />
    </svg>
  );
}
